import type { SectionTileCategoryRight2Small } from '#domains/resolver/board-section-data';
import { Tracktor } from 'react-tracktor';

import { IMAGE_SIZE_ONE_THIRD } from '../../BoardImageSizes';
import { BoardSectionItem } from '../BoardSectionItem';
import { BoardSectionItemFeed } from '../Items/BoardSectionItemFeed';
import { BoardSectionTileRow } from '../Tile/TileRow';
import { BoardSectionTileSection } from '../Tile/TileSection';

type Props = {
	boardSectionItems: SectionTileCategoryRight2Small['items'];
};

export function BoardSectionTileCategoryRight2({
	boardSectionItems: {
		left: [first, second],
		feedItems,
	},
}: Props) {
	if (first.type === 'empty' || second.type === 'empty') {
		return null;
	}

	return (
		<BoardSectionTileSection>
			<BoardSectionTileRow>
				<Tracktor trackingData={{ data: { inSectionPlacement: 0 } }}>
					<BoardSectionItem teaser={first} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 1 } }}>
					<BoardSectionItem teaser={second} sizes={IMAGE_SIZE_ONE_THIRD} />
				</Tracktor>

				<Tracktor trackingData={{ data: { inSectionPlacement: 2 } }}>
					<BoardSectionItemFeed teasers={feedItems} />
				</Tracktor>
			</BoardSectionTileRow>
		</BoardSectionTileSection>
	);
}
